// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"128":"bbc27c66","160":"bbc27c66","260":"22d10d96","321":"2b8557d6","489":"bbc27c66","611":"95d58372","797":"2b8557d6","843":"1ef242e0"}[chunkId] + ".chunk.css";
};